import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const headerTranslations = {
  pt: {
    home: "Início",
    contact: "Contato",
    terms: "Termos",
    privacy: "Privacidade",
    about: "Sobre",
  },
  en: {
    home: "Home",
    contact: "Contact",
    terms: "Terms",
    privacy: "Privacy",
    about: "About Us",
  },
  es: {
    home: "Inicio",
    contact: "Contacto",
    terms: "Términos",
    privacy: "Privacidad",
    about: "Sobre Nosotros",
  },
};

export default function Header() {
  const lang = localStorage.getItem("kitoLang") || navigator.language.slice(0, 2);
  const t = headerTranslations[lang] || headerTranslations.pt;

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <div className="site-brand">
          <span className="site-logo">
            <img src="/images/kito.png" alt="Kito App" />
          </span>
          <span className="site-name">Kito App</span>
        </div>

        <div className="site-nav-wrap">
          <nav className="site-nav">
            <Link to="/" className="site-link">{t.home}</Link>
            <Link to="/contato" className="site-link">{t.contact}</Link>
            <Link to="/termo-de-uso" className="site-link">{t.terms}</Link>
            <Link to="/politica-de-privacidade" className="site-link">{t.privacy}</Link>
            <Link to="/about" className="site-link">{t.about}</Link>
          </nav>

          <div className="site-flags">
            <button
              type="button"
              className="site-flag"
              title="Português"
              onClick={() => {
                localStorage.setItem("kitoLang", "pt");
                window.location.reload();
              }}
            >
              <img src="https://flagcdn.com/w40/br.png" alt="Português" />
            </button>
            <button
              type="button"
              className="site-flag"
              title="English"
              onClick={() => {
                localStorage.setItem("kitoLang", "en");
                window.location.reload();
              }}
            >
              <img src="https://flagcdn.com/w40/us.png" alt="English" />
            </button>
            <button
              type="button"
              className="site-flag"
              title="Español"
              onClick={() => {
                localStorage.setItem("kitoLang", "es");
                window.location.reload();
              }}
            >
              <img src="https://flagcdn.com/w40/es.png" alt="Español" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
